import PubSub from "underpub-js";

var Header = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-Header',
	};

	$.extend(true, this.options, options);

};

Header.prototype.init = function() {

	var self = this;
	var headerHeight = self.options.$el.height();
	
	window.addEventListener("scroll", function () {
		if(window.scrollY > headerHeight + 50) {
			self.options.$el.addClass(`${self.options.baseClass}--hide`);
		}
		if (window.scrollY > headerHeight + 100) {
			
			self.options.$el.addClass(`${self.options.baseClass}--fixed`);
			if (window.scrollY > headerHeight + 500) {
				self.options.$el.addClass(`${self.options.baseClass}--show`);
			}else {
				self.options.$el.removeClass(`${self.options.baseClass}--show`);
				
			}
		}else {
			self.options.$el.removeClass(`${self.options.baseClass}--fixed`);
			self.options.$el.removeClass(`${self.options.baseClass}--hide`);
		}
	});

};

export default Header;
